{
  "0464d777d1568a1c": "Delete message?",
  "07a2d579c3f0d325": "Starred",
  "0a1f2fbcba7a4924": "Message sent",
  "0d60084f056eb4cf": "No conversations yet",
  "0d79ff168b4abad5": "· edited",
  "0ec2ae49e4414937": "Was {{workerName}} a No Show?",
  "11dab6274664c362": "Reply to message",
  "11feeff6baecd5a9": "Don't send",
  "12d82ae5928141ae": "Select a conversation",
  "14d3e2bd48ff4eb2": "More chat options",
  "14e05c7949dda7ca": "These responses will be shared with the professional in the chat.",
  "155f816c0407310c": "Submit",
  "15d5681537d5b70c": "This action is reserved for professionals with slow or missing visit notes. Locking will:",
  "15db6cf63b74d63f": "This professional cannot be invited to shifts at this workplace.",
  "173874fc674b3464": "Cannot be assigned to new cases",
  "17a9724ab58b6c42": "Unsupported file type. Please upload images, PDFs, or Word documents.",
  "19766ed6ccb2f4a3": "Cancel",
  "19c73a5cdf346d96": "Professional",
  "1aa4263bbe43cfdd": "Channel filters",
  "1b9e1aa135771a2f": "Close image preview",
  "1b9f384c1436f607": "Unread",
  "1c7af185ab9ab67c": "Job listing: {{placementTitle}}",
  "206eea992f2daf12": "View calendar",
  "2355f73150190fc7": "Cancel reply",
  "2396999ffc3ba483": "This message will be permanently removed for everyone.",
  "2487e3d832ca50b9": "You proposed a new shift time",
  "257c8051763d5f71": "Share credentials",
  "25a54122b93c5f88": "Lock Professional's Account",
  "274888e3d8ba0795": "Unlock Professional",
  "299aff9380977cc5": "Retry?",
  "2b19d38ff893ed73": "Automated Message",
  "2b3f7fdef47be7d9": "Please use judgment and professionalism.",
  "2c19d584bf8ad518": "Mark as unread",
  "2e544a292f6979ed": "Shift",
  "314c0fae93ae57c3": "View candidate",
  "31fbef162594de01": "Continue",
  "37281adc1ef51df7": "Describe why this professional's account should be locked...",
  "37a407f7f7ca1e14": "Lock Professional",
  "3b14c5dc986f2a36": "Close chat",
  "3ed9b6a64daba284": "Interview scheduled",
  "3f3bbdf89cbfb1fe": "Loading shift times...",
  "4022255740ab5a30": "Application Received",
  "4165e2978c2117ef": "Chat messages",
  "419d2b38764f8681": "Review the sent home request",
  "41bedd1a62cf3920": "Shift details could not be loaded. You can still submit the rejection without a follow-up action.",
  "42b2a2a0d876aaf8": "Interview Canceled",
  "436f860b57898463": "Please fill out reason for approval.",
  "44b23f3add41fbac": "Starred professional",
  "464c4ffd019e1e96": "Edit",
  "4758b5bc7d94c1bb": "Are you sure you want to unlock this professional?",
  "4938e979a0d0a156": "Yes, {{workerName}} never showed up to work the shift",
  "497b1882c39ac540": "Loading shift details...",
  "4ac709aa58bcfe5d": "Unlock",
  "4e414af41b7d4876": "Hiring",
  "4e832591dc95eda7": "Did {{workerName}} leave the shift early?",
  "516efaba309fba5d": "Message cancelled",
  "5203691edc6eac2a": "Please provide context for your approval reason",
  "5268ce545cfd1bc5": "Failed to lock this professional. Please try again.",
  "538b6cc4892537c8": "Describe what needs to happen before this professional can be unlocked...",
  "554e7df8055a5b26": "Only workplace users can send messages",
  "588032878324b5e6": "Send now",
  "5ce4aeba4357203a": "Failed to delete message",
  "5d8f22798b0e32ef": "Failed to report No Show. Please try again.",
  "5e31e8926ceba729": "Message options",
  "61006b850c2d1765": "Yes, worker was sent home.",
  "6103ae51803696cf": "Scheduled interview invite pending",
  "653ecb88c925d69a": "Interview invite cancelled",
  "65e3db405524457a": "This will last for {{days}} days. Enter lock details on the next page.",
  "66aff25b2a4034ab": "Replying to {{senderName}}",
  "66b8e077d85fe969": "Failed to send message",
  "6973cb606bc78799": "Thanks for your response!",
  "6a63d328d7b3d4e8": "Invite to shift",
  "6a94bfa8b699d2e5": "The lock will expire automatically after {{days}} days.",
  "6c3fe8584f8cba3d": "No, don't approve",
  "6f0943b503a938bb": "Reason for Locking",
  "6f4cd7c8dcf57167": "Reason for rejection",
  "6fa271453f8ac490": "Cancel edit",
  "6fb5cd38b73ffa59": "{{workerName}}'s account has been deactivated and can no longer send or receive messages.",
  "7286a96c2bd8186e": "Interview invite sent",
  "72ed245d2cf11822": "Reasons",
  "7344c04e9e307c21": "Failed to report Worker Left Early. Please try again.",
  "73b0c119934508c5": "Message canceled",
  "73cb145a22b3d8e6": "How to Unlock",
  "73d963fcf950088e": "WPL Time:",
  "76900f1bfd16c8d4": "Back",
  "78f5975a5d705e95": "New message",
  "7ad7363a5819c924": "Professional's account locked",
  "7d99b198ba5bad55": "Cannot accept new Home Health visits",
  "7dbfd44a87232deb": "Editing message",
  "7dc2c9b04fedc9a4": "Invite to Shift",
  "7ea56b231dd1fba8": "You may provide context for your approval reason",
  "7f55382219f0202c": "Search...",
  "7fd435c1a03f8f28": "File size must be less than 10MB",
  "846d05b5aec949db": "Add to starred",
  "852df26908c3c970": "{{workerName}}'s interview has been canceled by the workplace.",
  "87f6dfda0977757d": "Please select if you'd like us to post an urgent replacement shift.",
  "87fbe4fb79b1d700": "Attach file",
  "895e24c74a7ddb71": "Failed to unlock this professional. Please try again.",
  "89713b9c9c1b8f65": "Accept",
  "8a7525b1492fb848": "Notes",
  "8b2bd68e24610c8d": "This is an automated message sent on behalf of your facility",
  "8b4a28105b186b0e": "Interview Invite",
  "8dc90f8c6f07b3a3": "Approve this shift as a sent home?",
  "8ec1b7b0dfed097f": "{{currentLength}}/{{minimumLength}} minimum characters",
  "905215e97d44789f": "Please add notes to describe why the worker was not sent home.",
  "90821a3431c5603c": "Do you accept this sent home request?",
  "9301b7e607985030": "Your message was cancelled successfully.",
  "93063f0beabb3a5d": "Prevent them from accepting new visits",
  "93a26b1eaff99b3a": "Send message",
  "93b9bd5f34693a9f": "PM Shift",
  "93c948f6c294adc0": "Failed to upload file",
  "942087cc2d41e013": "Retry",
  "94518be867eb2f8a": "Expiring in {{displayDuration}}",
  "97cce8bbb9df463f": "You sent multiple shift invites",
  "98dad1bca40bbcf9": "Your message was sent successfully.",
  "99c40ab405926cb5": "Date",
  "9a54e5b2b4151dfa": "Reason for approval",
  "9b9a8d05a7ec353b": "Read",
  "9c4ff530a4b48196": "No conversations match your filters",
  "9de4149fb9716cfc": "Download file",
  "9e91a3e9c73c3a08": "Prevent them from being assigned to new cases",
  "9f411825daab7e3e": "Please fill out reason for rejection.",
  "9faca3224d9578d1": "Interview Suggested",
  "a06faf2668c28d0b": "No messages",
  "a1911a805b2e584a": "No, worker was not sent home",
  "a20d12c5e9c428c3": "Thinking",
  "a2d285b352873457": "Decline",
  "a424e33d90931d1e": "Locked",
  "a52ace420f2175d0": "All",
  "a5e4ce04a6cd1577": "Yes, approve",
  "a67b04cd5c491d4d": "Worker",
  "a6a5fc451f8f8e92": "Professionals on your DNR list cannot be added to your starred list",
  "a7826132abbfe036": "Confirm No Show",
  "a7cf9363556dd4ca": "AM Shift",
  "ae55fc046c4cf3ae": "Failed to load conversations",
  "b0c1b5c59c40d7e4": "{{workerName}} is currently blocked from this workplace.",
  "b0f496c73d51b975": "Interview scheduled successfully",
  "b269519c244f2c88": "No messages yet. Start a conversation with {{workerName}}!",
  "b780d4652d4724a2": "Failed to mark chat as unread",
  "ba4a26dec0142695": "Failed to reject request",
  "bb1b36b33a11ea0f": "This professional's account has been locked by another workplace. While locked, this professional:",
  "bc1c7de0ef33b464": "Load more messages",
  "bd8f7395f7c52d38": "Locking this professional will:",
  "c16bc82bf1f04ede": "Sent",
  "c1c1009d3f37ec05": "Update",
  "c2a520b84ceea67c": "Flex",
  "c3812fc4acb861d5": "Remove",
  "c71cf96ff4711ee0": "Failed to create chat channel",
  "c821e8b037f955b7": "Mark conversation as unread",
  "c8df66c5fe3f97d0": "Close dialog",
  "c97583fe90258cd7": "Failed to approve request",
  "ccca181757536587": "Conversation",
  "ce071bf9950dfa05": "Failed to load chat messages. Please try again.",
  "d1bf045bb524dae5": "View details",
  "d456fc75664472cc": "Back to conversations",
  "d4788f256f730423": "View profile",
  "d9924a3cf77aeffe": "Failed to cancel message",
  "da8e926af6449411": "Failed to edit message",
  "db44b8db4f05d720": "Lock",
  "dc1011d87ddbaa17": "Worker asked me to cancel",
  "df576ba623e98119": "Yes, {{workerName}} never worked the complete shift",
  "e0e1ef8d687774e2": "Describe the outstanding or overdue notes — include visit dates where possible.",
  "e2d0a54968ead24e": "Delete",
  "e31658dca0dfb098": "Only lock if this professional has outstanding or overdue notes. The lock lasts {{days}} days. Enter details on the next page.",
  "e482250d535eb95b": "Agent is typing",
  "e7eab2eac45a75af": "Book Interview",
  "e82ce23a48d44e4a": "Please note this reason will be shared with the worker.",
  "e9bddf7360b6dc62": "Type your message...",
  "eb109d5d22dd2477": "Invite as",
  "eb13fd621c1e72ae": "Manage jobs",
  "ec711c8c4d8a69f5": "Interview invite canceled",
  "ed4d44fa08fd38d0": "Report Worker Left Early",
  "efffe1f9cd058fbe": "Scheduled interview invite",
  "f1133f6566cd1093": "Remove from starred",
  "f66617b0bd919384": "You sent a shift invite",
  "f6820511a8178983": "Chat message",
  "f8d5b1186d791b61": "NOC Shift",
  "fafdd9b59e05d383": "Your message was canceled successfully.",
  "fcb2f91b76efc2d6": "Interview Cancelled",
  "fd9b5c64be299307": "Chat Unavailable",
  "ffa998e6db888ed3": "Describe what note submissions are required before this professional can be unlocked."
}
